import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';
import Contact from 'src/app/model/Contact/contact';
import { Subject } from 'rxjs';

@Component({
  selector: 'create-view-picker',
  templateUrl: './create-view-picker.component.html',
  styleUrls: ['./create-view-picker.component.scss'],
})
export class CreateViewPickerComponent extends SubscriptionBasedComponent {
  @Input()
  project: Project;

  @Input()
  subProject: SubProject;

  @Input()
  submitProjectResult: Subject<any>;

  @Input()
  client: boolean = true;

  @Input()
  adminCreate: boolean = false;

  @Output()
  submitProject = new EventEmitter();

  @Output()
  updateOtherContacts = new EventEmitter();

  gettingNewComponent = false;

  doSubmitProject() {
    this.submitProject.emit();
  }

  emitUpdateOtherContacts(contacts: Contact[]): void {
    this.updateOtherContacts.emit(contacts);
  }
}
